import { setErrorObject } from '../../actions/shared/HTTPError';
import fetcher from '../../modules/ajio-fetch';
import {
  fetchGetJSONReqOpts,
  fetchGetJSONResHandler,
  getErrorStatusCode,
  errorParser,
  tokenReCreateParser
} from '../../modules/ajio-fetch/utils';

import { setOrder } from './payment';
import properties from '../../modules/ajio-util/properties';

export function getOrder(requestObj = {}, callback) {
  const { isRequestOrginIsBrowser = false, request = {} } = requestObj;
  let { headers: { host = '' } = {}, params: { id = '' } = {} } = request;

  return dispatch => {
    let apiEndPoint;
    let body = {};
    if (isRequestOrginIsBrowser) {
      ({ id = '' } = requestObj);
      apiEndPoint = `/api/cart/order/${id}`;
    } else {
      apiEndPoint = `http://${host}/api/cart/order/${id}`;
      body = {
        A: request.cookies.A,
        U: request.cookies.U,
        C: request.cookies.C
      };
    }
    return new Promise((resolve, reject) => {
      return fetcher(
        apiEndPoint,
        fetchGetJSONReqOpts({
          body: JSON.stringify(body),
          method: 'POST',
          headers: { 'content-type': 'application/json' },
          credentials: 'include'
        })
      )
        .then(fetchGetJSONResHandler)
        .then(response => {
          console.log("TRACK POINT 6 ~ response:", response)
          dispatch(setOrder(response));
          resolve(response);
        })
        .catch(error => {
          const statusCode = getErrorStatusCode(error);
          errorParser(error, statusCode).then((errorObj = {}) => {
            if (statusCode === 401) {
              tokenReCreateParser(statusCode, errorObj).then(() => {
                getOrder(requestObj, callback)(dispatch);
              });
            }
            dispatch(setErrorObject(errorObj));
            reject(errorObj);
          });
        });
    });
  };
}

export function sendFeedback(feedbackObj) {
  const apiEndPoint = `/api/my-account/feedback`;
  return fetcher(
    apiEndPoint,
    fetchGetJSONReqOpts({
      method: 'POST',
      body: JSON.stringify({ feedbackObj }),
      headers: { 'content-type': 'application/json', credentials: 'include' },
      credentials: 'include'
    })
  )
    .then(response => {
      if (response.status) {
        return Promise.resolve(response);
        //  window.location="/";
      }
    })
    .catch(error => {
      const statusCode = getErrorStatusCode(error);
      errorParser(error, statusCode).then((errorObj = {}) => {
        if (statusCode === 401) {
          tokenReCreateParser(statusCode, errorObj).then(() => {
            sendFeedback(feedbackObj);
          });
        }
      });
    });
}
